<template>
  <svg
    version="1.1"
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 512 512"
    style="enable-background: new 0 0 512 512"
    xml:space="preserve"
  >
    <path
      :style="{ fill: isCloseTo ? '#52a301' : '#fd003a' }"
      d="M256,0.122C148.624,0.122,61.046,87.7,61.046,195.076c0,42.589,13.496,83.079,38.992,116.971
	l143.964,193.955C246.099,509,251.8,512,256,512c4.5,0,9.9-3.299,11.998-5.999c0.597-0.901,145.464-196.054,146.665-197.854
	c0.3,0,0.3,0,0.3-0.298c23.395-32.993,35.99-71.984,35.99-112.773C450.954,87.701,363.376,0.122,256,0.122z M256,300.051
	c-57.884,0-104.975-47.089-104.975-104.975S198.116,90.101,256,90.101s104.975,47.089,104.975,104.975S313.884,300.051,256,300.051z
	"
    />
    <path
      :style="{ fill: isCloseTo ? '#4e9607' : '#dd0030' }"
      d="M256,0v89.979c57.884,0,104.975,47.089,104.975,104.975S313.884,299.929,256,299.929v211.949
	c4.5,0,9.9-3.299,11.998-5.999c0.597-0.901,145.464-196.054,146.665-197.854c0.3,0,0.3,0,0.3-0.298
	c23.395-32.993,35.99-71.984,35.99-112.773C450.954,87.578,363.376,0,256,0z"
    />
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
  </svg>
</template>

<script>
export default {
  name: "LocationIcon",
  props: {
    isCloseTo: {
      type: Boolean,
      required: false,
      default: false
    }
  }
};
</script>

<style></style>
